import React from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Box, Button, Card, CardContent, Typography, Avatar, Divider } from '@mui/material';
import { clearApplicationStorage } from '../utils/localStorage';

const ProfilePage = () => {
    const { keycloak, initialized } = useKeycloak();

    const handleLogout = () => {
        try {
            // Clear application-specific localStorage before logout
            clearApplicationStorage();
            
            // Small delay to ensure cleanup completes before logout redirect
            setTimeout(() => {
                keycloak.logout();
            }, 100);
        } catch (error) {
            console.error('Error during logout cleanup:', error);
            // Still proceed with logout even if cleanup fails
            keycloak.logout();
        }
    };

    if (!initialized) {
        return <div>Loading...</div>;
    }

    const { idTokenParsed: token } = keycloak;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3, minHeight: 'calc(100vh - 60px)' }}>
            <Card sx={{ minWidth: 275, maxWidth: 600, width: '100%', boxShadow: 3, borderRadius: 2 }}>
                <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <Avatar sx={{ width: 80, height: 80, mr: 2, bgcolor: 'primary.main' }}>
                            <Typography variant="h4">{token.given_name?.[0]}{token.family_name?.[0]}</Typography>
                        </Avatar>
                        <Box>
                            <Typography variant="h4" component="div" fontWeight="bold">
                                {token.name}
                            </Typography>
                            <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                {token.email}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom>Profile Information</Typography>
                    <Typography variant="body1"><strong>First Name:</strong> {token.given_name}</Typography>
                    <Typography variant="body1"><strong>Last Name:</strong> {token.family_name}</Typography>
                    <Typography variant="body1"><strong>Username:</strong> {token.preferred_username}</Typography>
                    <Typography variant="body1"><strong>User ID:</strong> {token.user_id}</Typography>

                    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant="contained" color="primary" onClick={handleLogout}>
                            Logout
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ProfilePage; 